import * as actionTypes from './actionTypes';

export const setFormTemplate = (formTemplate = {}) => {
  return {
    type: actionTypes.SET_FORM_TEMPLATE,
    value: formTemplate,
  };
};

export const setFormTemplateVersion = (version = {}) => {
  return {
    type: actionTypes.SET_FORM_TEMPLATE_VERSION,
    value: version,
  };
};

export const addANewField = (newField = {}) => {
  return {
    type: actionTypes.ADD_A_NEW_FIELD,
    value: newField,
  };
};

export const setFieldValue = (position, fieldName, fieldValue) => {
  return {
    type: actionTypes.SET_FIELD_VALUE,
    payload: {
      position,
      fieldName,
      fieldValue,
    },
  };
};

export const setOtherOptionValue = (position, otherValue) => {
  return {
    type: actionTypes.SET_FIELD_OTHER_ENABLED,
    payload: {
      position,
      otherValue,
    },
  };
};

export const setOtherFieldLabel = (position, otherFieldLabel) => {
  return {
    type: actionTypes.SET_OTHER_FIELD_LABEL,
    payload: {
      position,
      otherFieldLabel,
    },
  };
};

export const resetField = (resetPosition, resetFieldName) => {
  return {
    type: actionTypes.RESET_FIELD,
    payload: {
      resetPosition,
      resetFieldName,
    },
  };
};

export const setActiveAccordion = (index) => {
  return {
    type: actionTypes.SET_ACTIVE_ACCORDION,
    value: index,
  };
};

export const setInactiveAccordion = (index) => {
  return {
    type: actionTypes.SET_INACTIVE_ACCORDION,
    value: index,
  };
};

export const setFormTemplateValue = (templateAttributeId, templateValue) => {
  return {
    type: actionTypes.SET_TEMPLATE_VALUE,
    payload: {
      templateAttributeId,
      templateValue,
    },
  };
};

export const setRearrangePosition = (rearrangeFields, draggedItem, drugOverIndex) => {
  return {
    type: actionTypes.SET_REARRANGE_POSITION,
    payload: {
      rearrangeFields,
      draggedItem,
      drugOverIndex,
    },
  };
};

export const removeField = (id) => {
  return {
    type: actionTypes.REMOVE_FIELD,
    payload: {
      id,
    },
  };
};
